<template>
	<div>
		<h3 class="font-semibold text-lg mt-8">Página não encontrada!</h3>
	</div>
</template>

<script setup>
</script>

<style scoped>
h3 {
	position: relative;
	width: 100%;
	text-align: center;
	line-height: 30px;
	top: 50px;
}
</style>